import { render } from "./SoDoCho.vue?vue&type=template&id=0a4caf37&scoped=true"
import script from "./SoDoCho.vue?vue&type=script&lang=js"
export * from "./SoDoCho.vue?vue&type=script&lang=js"

import "./SoDoCho.vue?vue&type=style&index=0&id=0a4caf37&lang=scss&scoped=true"

import exportComponent from "E:\\SonPhat\\Project\\BanVe\\banvetaimaypos_fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a4caf37"]])

export default __exports__